import {useRouter} from 'next/router'

export const useShoppingListId = (): string | null => {
  const router = useRouter()
  return typeof router.query.listId === 'string' ? router.query.listId : null
}
